import { render, staticRenderFns } from "./DaysFromNow.vue?vue&type=template&id=70f2a6b2"
import script from "./DaysFromNow.vue?vue&type=script&lang=js"
export * from "./DaysFromNow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports